import { Card, CardContent } from '@frontend/shadcn/components/ui/card';
import {
    Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from '@frontend/shadcn/components/ui/accordion';
import {
    Tabs, TabsContent, TabsList, TabsTrigger,
} from '@frontend/shadcn/components/ui/tabs';
import React, { useState } from 'react';
import { ShopifyIcon } from '@revfluence/fresh-icons/brands/esm';
import RefreshMultipleShopifyStoreStats from './Dashboard/RefreshMultipleShopifyStoreStats';
import { GetMultipleShopifyStats_storeStats } from '../queries/types/GetMultipleShopifyStats';

interface OfferDashboardTabsProps {
    storeWiseConversions: GetMultipleShopifyStats_storeStats[];
}

const tabItems = [
    // { id: 'boosts-performance', label: <span className="flex items-center gap-2"><span role="img" aria-label="trophy">🏆</span>Boosts Performance</span> },
    // { id: 'tiers-performance', label: <span className="flex items-center gap-2"><span role="img" aria-label="bolt">⚡</span>Tiers Performance</span> },
    { id: 'store-wise-conversions', label: <span className="flex items-center gap-2"><ShopifyIcon className="h-4 w-4 text-primary" />Store wise conversions</span> },
];

export function OfferDashboardTabs({
    storeWiseConversions,
}: OfferDashboardTabsProps): JSX.Element {
    const [activeTab, setActiveTab] = useState('store-wise-conversions');
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
      <Card className="flex flex-col items-start gap-4 p-0">
        <CardContent className="p-0 w-full">
          <Accordion
            type="single"
            defaultValue=""
            collapsible
            className="w-full"
            onValueChange={(value) => setIsCollapsed(!value)}
          >
            <AccordionItem value="offer-details">
              <AccordionTrigger className="flex items-center gap-2 px-4 pt-3 pb-1 rounded-none !shadow-none bg-transparent  w-full">
                <div className="flex flex-wrap justify-start w-max">
                  {tabItems.map((tab) => (
                    <div
                      key={tab.id}
                      className={`px-4  flex-1 sm:flex-auto justify-start cursor-pointer ${
                        activeTab === tab.id && !isCollapsed ? 'border-b-2 border-primary font-medium py-3' : ''
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setActiveTab(tab.id);
                      }}
                    >
                      {tab.label}
                    </div>
                  ))}
                </div>
              </AccordionTrigger>
              <AccordionContent className="p-0">
                <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
                  <TabsList className="hidden">
                    {tabItems.map((tab) => (
                      <TabsTrigger
                        key={tab.id}
                        value={tab.id}
                        className="hidden"
                      >
                        {tab.label}
                      </TabsTrigger>
                    ))}
                  </TabsList>

                  {/* <TabsContent className="p-4" value="boosts-performance">
                    <div className="py-8 text-center text-lg">sample text for boosts performance</div>
                  </TabsContent>
                  <TabsContent className="p-4" value="tiers-performance">
                    <div className="py-8 text-center text-lg">sample text for tiers performance</div>
                  </TabsContent> */}
                  <TabsContent className="p-4" value="store-wise-conversions">
                    <RefreshMultipleShopifyStoreStats data={storeWiseConversions} />
                  </TabsContent>
                </Tabs>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </CardContent>
      </Card>
    );
}

export default OfferDashboardTabs;
